export default "__VITE_ASSET__IH6Cto3e__"